/**
* 前台总入口
* Created by dxw on 2020/03/17.
*/
<template>
  <div class="help-center">
    <!--头部-->
    <!--<div class="help-top">
      <div class="top-center">
        <img src="../../assets/images/jlw02.png">
        <ul>
          <li><a href="/">首页</a></li>
          <li><a href="/article">新闻中心</a></li>
          <li><a href="/environmental">将来学院</a></li>
          <li><a>采销商城</a></li>
          <li><a>关于我们</a></li>
        </ul>
        <div class="top-center-input" @keyup.enter="search">
          <i class="iconfont" @click="search">&#xe667;</i>
          <input type="text" v-model="value" placeholder="请输入产品关键字"/>
        </div>
        <div class="menus">
          <div v-if="token" class="user-message">
          <span class="el-dropdown-link user-img">
            <img :src="user.headIconUrl" class="face" :alt="user.nickName">
          </span>
            <span class="name">{{ user.nickName }}</span>
            <a :href="workbenchLink" target="_blank">前往工作台</a>
            <a href="#" @click="goLoginOut">退出登录</a>
          </div>
          <div class="top-center-account">
            <router-link class="login" to="/login" target="_blank" v-if="!token">
              登录
            </router-link>
            <router-link class="login" to="/register" target="_blank" v-if="!token">
              注册
            </router-link>
          </div>
        </div>
      </div>
    </div>-->

    <!--面包屑 / 搜索框-->
    <div class="bread-crumbs">
      <a class="crumbs" href="/">
        首页
      </a>
      <i class="iconfont">/</i>
      <a class="crumbs" href="/help-center">
        帮助中心
      </a>
      <i class="iconfont" v-if="helpInfo.problemName">/</i>
      <a class="crumbs active" v-if="helpInfo.problemName" :href="'/help-center?id='+helpInfo.id">
        {{ helpInfo.problemName }}
      </a>

      <!--搜索框-->
      <div class="header-search">
        <el-select
            v-model="optionsValue"
            class="inline-input"
            clearable
            @keyup.enter.native="handleSelect"
            filterable placeholder="请输入问题名称搜索">
          <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.problemName"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button slot="append" @click="handleSelect">
          <i class="iconfont">&#xe667;</i> 搜索
        </el-button>
       <!-- <el-autocomplete
            class="inline-input"
            v-model="articleName"
            :fetch-suggestions="querySearch"
            placeholder="请输入问题名称搜索"
            :trigger-on-focus="false"
            @select="handleSelect"
            @keyup.enter.native="handleSelect"
            icon="search"
        >

        </el-autocomplete>-->
      </div>
    </div>

    <!--内容区-->
    <div class="help-contain"  v-if="helpList && helpList.length > 0">
      <!--栏目-->
      <div class="custom-module-content">
        <div class="setup-wizard-list" v-for="(item,index) in helpList"
             :key="item.id">
          <div class="list-first">
            <div class="title">{{ item.columnName }}</div>
          </div>
          <div class="list-second" v-for="(items,i) in item.helpCenterProblemList"
               :key="items.id"
               :class="{'active':helpInfo.id === items.id}"
               @click.stop="jumpDetails(items.id)"
          >
            <i class="iconfont">&#xe626;</i>
            <div class="title">{{ items.problemName }}</div>
          </div>
        </div>
      </div>

      <!--详情-->
      <div class="article-info" v-loading="loading">
        <div class="header">
          <span class="title">{{ helpInfo.columnName }}</span>
          <span class="interval">>></span>
          <span class="title active">{{ helpInfo.problemName }}</span>
        </div>
        <div class="html" v-html="helpInfo.problemDesc"></div>
      </div>
    </div>
    <div class="default" v-else>暂无内容</div>
    <!--底部-->

  </div>
</template>

<script>
import AppConfig from '../../appConfig'

export default {
  name: 'help-center',
  metaInfo: {
    title: '帮助中心 - 将来网(JIANGLAIWANG.COM)-环保工业品综合平台', // set a title
    meta: [
      {
        name: 'keywords',
        content: '将来网,工业品B2B平台,GF,东丽,反渗透膜'
      },
      {
        name: 'description',
        content: '将来网(JIANGLAIWANG.COM) -专业的综合工业品平台，提供专业售前、售后服务！'
      }
    ],
  },
  components: {},
  data() {
    return {
      mallUrl: AppConfig.API.RECEPTION_URL,

      id: this.$route.query.id,

      value: '',
      token: this.$store.state.token,
      user: this.$store.state.user,
      helpList: [],
      workbenchLink: AppConfig.API.REDIRECT_URL,
      articleInfo: '',
      current: 0,
      current1: 0,
      articleName: '',
      problemName: [],

      loading: false,

      //当前帮助信息详情
      helpInfo: {
        id: '',
        //栏目id
        columnId: '',
        //栏目名称
        columnName: "",
        //内容
        problemDesc: "",
        // 标题
        problemName: "",
      },
      options: [],
      optionsValue: '',

    }
  },
  methods: {

    getOptionsSearch(){
      let obj = {
        pageIndex: 0,
        pageSize: 0
      }
      this.$httpV3.post('harbor/help/center/problem/list', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          let list = res.data.data.list || []
          this.options = list.map(item => item)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //搜索帮助建议列表
    querySearch(queryString, cb) {
      console.log(queryString, cb)
      let obj = {
        pageIndex: 0,
        pageSize: 0,
        queryStr: queryString
      }
      this.$httpV3.post('harbor/help/center/problem/list', obj).then(res => {
        if (Number(res.data.code) === 10000) {
          this.problemName = res.data.data.list
          if (this.problemName) {

            for (let i = 0; i < this.problemName.length; i++) {
              this.$set(this.problemName[i], 'value', res.data.data.list[i].problemName)
              //this.problemName[i].value = res.data.data[i].problemName
            }
            console.log(this.problemName)
          }

          cb(this.problemName);
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //选中搜索效果
    handleSelect() {
      if (this.optionsValue){
        this.goPageSecond(this.optionsValue)
      }
    },
    searchValueSelect() {
      this.$message.info("请输入关键字后根据下拉提示选择")
    },

    // 跳转详情
    jumpDetails(id) {
      if (window.history) {
        if (this.articleName) {
          this.articleName = ''
        }

        // 更新URL参数实现不刷新页面
        let shortParam = this.formatObjToParamStr({id: this.id})
        window.history.pushState(null, null, shortParam)

        // 支持History
        this.goPageSecond(id)
      } else {
        // 不支持History（直接跳转）
        window.location.href = '/help-center?id=' + id
      }
    },
    //获取帮助详情
    goPageSecond(id) {
      let obj = {
        id: id
      }
      this.loading = true
      this.$httpV3.post('harbor/help/center/problem/get', obj)
          .then(res => {
            this.loading = false
            if (Number(res.data.code) === 10000) {
              this.helpInfo = res.data.data
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            this.loading = true
          })
    },

    //收起栏目
    chooseSecondListOther(i) {
      this.helpList[i].showEdit = false
    },
    //展开栏目
    chooseSecondList(i) {
      this.helpList[i].showEdit = !this.helpList[i].showEdit
    },

    //搜索
    search() {
      if (!this.value) {
        this.$message.info("请输入关键字")
        return false
      }
      this.automatic(this.mallUrl + '/goods-list?searchValue=' + this.value)
    },

    //获取栏目列表
    getColumnList() {
      this.$httpV3.post('harbor/help/center/column/list/tree')
          .then(res => {
            if (Number(res.data.code) === 10000) {
              let list = res.data.data
              if (list) {
                let helpInfo = {}
                list.forEach((item, i) => {
                  if (i > 0) {
                    item.showEdit = false
                  } else {
                    item.showEdit = true
                  }

                  //获取首个帮助内容id
                  if (!helpInfo.id) {
                    if (item.helpCenterProblemList && item.helpCenterProblemList.length > 0) {
                      helpInfo = item.helpCenterProblemList[0]
                    }
                  }
                })

                //没有指定id是获取首个内容
                if (!this.id) {
                  this.goPageSecond(helpInfo.id)
                }
              }
              this.helpList = list
            } else {
              this.$message.error(res.data.msg)
            }
          })
    },
  },
  created() {
    this.getColumnList()
    this.getOptionsSearch()
  },
  mounted() {
    if (this.id) {
      this.goPageSecond(this.id)
    }


  }
}
</script>

<style lang="stylus" type="text/stylus">
.help-center
  background-color #f7f8fa

  .bread-crumbs
    width 1200px
    margin 0 auto
    display block
    height 74px
    .crumbs
      display inline-block
      color #666
      cursor pointer
      position relative
      height 34px
      line-height 34px
      vertical-align top
      margin 0 5px 0 0
      font-size 14px
      &.active, &:hover
        color #347eff
      &.active
        &:hover
          font-weight bold
      &.btn-bold
        font-weight bold
      &.btn
        line-height 20px
        padding 0 0 0 4px
        background #f3f3f3
        border 1px solid #ddd
        font-size 12px
        &:hover
          border-color #f73859
          background #fff
          .title
            color #666
          .iconfont
            color #ffffff
            background #f73859
      .title
        display inline-block
        font-size 12px
        vertical-align top
      .info
        display inline-block
        font-size 12px
        color #f73859
        vertical-align top
        max-width 80px
        text-overflow ellipsis
        white-space nowrap
        overflow hidden
      .iconfont
        text-align center
        vertical-align top
        display inline-block
        margin-right 0
        margin-left 5px
        width 22px
        font-size 12px

    > .iconfont
      margin 0 5px 5px 0
      vertical-align top
      display inline-block
      font-size 12px
      color #999999
      line-height 34px

  .header-search
    float right
    display flex
    .el-button{
      border-radius 0 16px 16px 0 !important
      display block
    }
    .el-input
      width 310px
      height 34px

    .el-input__inner
      border 2px solid #347fff
      padding-left 15px
      border-radius 16px 0 0 16px
      &:focus
        border-color #347fff

    .el-input-group__append
      width 90px
      border 0
      border-radius 0 16px 16px 0
      overflow hidden
      font-size 0

    .el-input-group__prepend
      min-width 100px
      color #1f2d3d
      background transparent
      border-radius 0
      border 2px solid #3daaed
      border-right-style none
      .el-input__inner
        border-right none

    .el-button
      width 90px
      height 34px
      border none
      background #347fff !important
      color #ffffff !important
      border-radius 0
      font-size 14px
      padding 0
      text-align center
      line-height 34px

  .help-top
    width 100%
    background-color #ffffff

    .top-center
      width 1200px
      padding 15px 0 12px 0
      margin 0 auto
      display flex
      align-items center

      img
        cursor pointer

      ul
        display flex
        margin-left 65px

        .el-dropdown
          .el-dropdown-link
            font-size 16px

        li
          display inline-block
          margin-right 18px
          font-size 14px
          cursor pointer

          a
            font-size 14px

          &:hover
            color #347eff

      .top-center-input
        margin-left 70px
        position relative

        input
          border 1px solid #e6e6e7
          border-radius 15px
          width 250px
          height 30px
          background-color #f4f4f4
          text-indent 10px

        i
          position absolute
          cursor pointer
          right 10px
          top 4px
          font-size 16px
          color #000000

      .menus
        display flex
        vertical-align top
        margin 7px 7px 7px 20px

        .user-message
          display flex
          align-items center
          font-size 0
          position relative

          .user-img
            display inline-block
            overflow hidden
            border-radius 100%
            height 36px
            width 36px
            cursor pointer
            margin-right 5px

            img
              height 100%
              width 100%

          .name
            margin-right 5px
            display inline-block
            color #666666
            font-size 14px
            max-width 50px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            vertical-align top

          .grade
            margin-right 5px
            height 18px
            background #4a9bff
            color #fff
            padding 0 3px
            font-weight bold
            margin-left 5px
            font-size 12px

          a
            margin-right 5px
            display inline-block
            margin-left 5px
            color #347eff
            font-size 12px

            &:hover
              color #0ab1fc

        i
          color #999

        span
          color #999

        .top-center-account
          margin-left 30px

          .login
            margin-left 10px
            width 60px
            height 30px
            display inline-block
            font-size 14px
            text-align center
            line-height 30px
            color: #347eff
            background-color #ffffff
            border-radius 5px
            border 1px solid #347eff

            &:hover
              color #ffffff
              background-color #347eff

      .user-message
        display inline-block

        font-size 0
        position relative

        .user-img
          display inline-block
          overflow hidden
          border-radius 100%
          height 36px
          width 36px
          cursor pointer

          img
            height 100%
            width 100%

        .user-name
          max-width 130px
          overflow hidden
          text-overflow ellipsis
          cursor pointer
          padding 5px 10px
          border-radius 3px
          font-size 15px

          &:hover
            background rgba(255, 255, 255, .2)

        .user-popup
          display none
          z-index 999
          position absolute
          top 117%
          right 0
          background: rgba(255, 255, 255, 0.97);
          box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.06);
          border 1px solid #ebebeb
          border-radius 4px
          width 286px

          .user-item
            display flex
            align-items center
            justify-content center
            font-size 12px
            padding 15px
            border-bottom 1px solid #e9e7e8
            color #666666

            &:last-child
              border-bottom 0
              padding 8px 15px

            .info
              display block
              width 100%
              vertical-align top
              line-height 20px

              .name
                display inline-block
                color #666666
                font-size 14px
                max-width 50px
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                vertical-align top

              .grade
                background #4a9bff
                color #fff
                padding 0 3px
                font-weight bold
                margin-left 5px
                font-size 12px

              a
                display inline-block
                margin-left 5px
                color #347eff
                font-size 12px

                &:hover
                  color #0ab1fc

              .descr
                display inline-block
                color #999
                max-width 130px
                overflow hidden
                text-overflow ellipsis
                white-space nowrap

            .user-icon
              display inline-block
              width 50px
              height 50px
              border-radius 25px
              margin-right 15px

            .link
              width 100%

              .item
                font-size 0

              a
                display inline-block
                width 50px
                margin-right 18px

                &:last-child
                  margin-right 0

                i
                  display inline-block
                  width 50px
                  height 50px
                  text-align center
                  line-height 50px
                  font-size 28px
                  background linear-gradient(to top, #57acff, #3783ff) #3783ff
                  border-radius 6px
                  color #fff

                span
                  display inline-block
                  margin-top 8px
                  font-size 12px

                &:hover
                  color #57acff

                  i
                    background #57acff

            .item-bottom
              width 100%
              line-height 20px

              .user-fun
                a
                  display inline-block
                  font-size 12px
                  color #999

                  &:hover
                    color #347eff

                span
                  vertical-align top
                  display inline-block

                i
                  display inline-block
                  width 16px
                  height 16px
                  border-radius 100%
                  text-align center
                  line-height 16px
                  font-size 10px
                  vertical-align middle
                  color #fff

              .login-out
                cursor pointer
                color #999

                &:hover
                  color #347eff

          /*箭头上-边框*/

          &::before
            content ''
            width 0
            height 0
            border-width 6px
            border-style solid
            border-color transparent transparent #ebebeb transparent
            position absolute
            top -12px
            right 12px

          /*箭头上*/

          &::after
            content ''
            width 0
            height 0
            border-width 4px
            border-style solid
            border-color transparent transparent #fff transparent
            position absolute
            top -8px
            right 14px

        &:hover
          .user-popup
            display block

  .help-search
    width 1200px
    margin 20px auto
    display flex
    justify-content flex-end
    padding-top 20px

    .inline-input
      width 340px

      .el-input input:focus
        border-color #dddddd

      .el-input__inner
        border-radius 20px

  .help-contain
    width 1200px
    margin 0 auto
    display flex

    .custom-module-content
      max-height 900px
      background-color #ffffff
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.06)
      width 320px
      padding 15px
      overflow auto
      margin-right 20px

      .setup-wizard-list
        flex 1
        display block
        margin-bottom 15px
        border-bottom 1px solid #dddddd
        padding-bottom 15px
        &:last-child
          border-bottom 0
        .list-first
          cursor pointer
          user-select: none;
          padding 5px 0
          margin-bottom 10px
          .title
            color #333
            font-size 16px
            display inline-block

        .list-second
          padding 5px 0 5px 15px
          cursor pointer
          user-select: none;
          display flex
          align-items center
          .title
            color #666666
            font-size 14px
            display inline-block

          &.active
            color #347eff
            .title
              color #347eff
          &:hover
            text-decoration underline

    .article-info
      background-color #ffffff
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.06)
      overflow hidden
      width 900px
      padding 10px
      .header
        font-size 16px
        padding 15px
        border-bottom 1px solid #ddd
        margin-bottom 15px
        .title
          display inline-block
          color #666
          &.active
            color #333
        span
          margin-right 5px
          &:last-child
            margin-right 0
      .html
        img
          max-width 100%
          max-height 100%
  .default{
    display flex
    align-items center
    justify-content center
    color #999
    font-size 24px
    font-weight bolder
    padding 217px 0
  }
</style>



// WEBPACK FOOTER //
// src/pages/help-center/index.vue